import { useEffect, useRef, useState } from "react";

const OtpInput = ({ length = 4, onOtpSubmit = () => { }, pageNames }) => {
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const inputRefs = useRef([]);

  useEffect(() => {
    if (pageNames === "reotp") {
      setOtp(new Array(length).fill(""));
    }
  }, [pageNames, length]);

  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  const handleChange = (index, e) => {
    const value = e.target.value;
    if (isNaN(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value.substring(value.length - 1);
    setOtp(newOtp);
    onOtpSubmit(newOtp.join(""));

    // Move focus to next input
    if (value && index < length - 1 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleClick = (index) => {
    inputRefs.current[index].setSelectionRange(1, 1);
    if (index > 0 && !otp[index - 1]) {
      inputRefs.current[otp.indexOf("")]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (
      e.key === "Backspace" &&
      !otp[index] &&
      index > 0 &&
      inputRefs.current[index - 1]
    ) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("Text").trim();

    if (!pastedData || isNaN(pastedData)) return;

    const pastedOtp = pastedData.split("").slice(0, length);
    const newOtp = [...otp];

    for (let i = 0; i < length; i++) {
      newOtp[i] = pastedOtp[i] || "";
    }

    setOtp(newOtp);
    onOtpSubmit(newOtp.join(""));

    // Optionally, move focus to the last filled input
    const nextIndex = Math.min(pastedOtp.length - 1, length - 1);
    inputRefs.current[nextIndex]?.focus();
  };

  return (
    <div className="w-full flex justify-between">
      {otp.map((value, index) => (
        <input
          key={index}
          type="text"
          ref={(input) => (inputRefs.current[index] = input)}
          value={value}
          inputMode="numeric"
          onChange={(e) => handleChange(index, e)}
          onClick={() => handleClick(index)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          onPaste={handlePaste} // ✅ added
          className="w-[51px] h-[51px] md:w-[54px] md:h-[54px] text-center text-base border-otp-border border focus:border-blue-500 focus:outline-none rounded-lg"
        />
      ))}
    </div>
  );
};

export default OtpInput;
